import * as React from "react"
import { Link, FieldProps, useRecordContext } from "react-admin"

import FullNameField from "./FullNameField"
import { Customer } from "../types"

const UserLinkField = (props: FieldProps<Customer>) => {
  const record = useRecordContext<Customer>()
  if (!record) {
    return null
  }
  return (
    <Link to={`/app-users/${record.id}`}>
      <FullNameField />
    </Link>
  )
}

UserLinkField.defaultProps = {
  source: "customer_id",
}

export default UserLinkField
